import * as actionTypes from './actionTypes';

export function receiveUserCredentials(uid: string, error: Error) {
    return {
        type: actionTypes.RECEIVE_USER_CREDENTIALS,
        uid,
        error,
    };
}
